module.exports = __webpack_public_path__ + "img/planBlack.33e59a0b.png";